import { Activity, LogOut, LayoutDashboard, BarChart2 } from 'lucide-react';
import { NavLink } from 'react-router-dom';

export default function Header({ user, onLogout }) {
  const email = user?.signInDetails?.loginId ?? '';

  const navCls = ({ isActive }) =>
    `flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all ${
      isActive
        ? 'bg-blue-600 text-white shadow-sm'
        : 'text-slate-500 hover:bg-slate-100 hover:text-slate-800'
    }`;

  return (
    <header className='bg-white border-b border-gray-200 shadow-sm'>
      <div className='max-w-7xl mx-auto px-6 py-0 flex items-center justify-between h-16'>

        {/* Logo */}
        <div className='flex items-center gap-8'>
          <div className='flex items-center gap-2.5'>
            <div className='w-8 h-8 bg-blue-600 rounded-lg flex items-center
                            justify-center shadow-sm'>
              <Activity size={16} className='text-white' />
            </div>
            <div>
              <span className='font-bold text-slate-800 text-sm leading-none block'>
                Cloud4Feed
              </span>
              <span className='text-xs text-slate-400 leading-none block'>
                System Monitoring
              </span>
            </div>
          </div>

          {/* Nav */}
          <nav className='flex items-center gap-1'>
            <NavLink to='/' end className={navCls}>
              <LayoutDashboard size={15} />
              Genel Görünüm
            </NavLink>
            <NavLink to='/usage' className={navCls}>
              <BarChart2 size={15} />
              Kullanım Analizi
            </NavLink>
          </nav>
        </div>

        {/* Kullanıcı */}
        <div className='flex items-center gap-4'>
          <div className='flex items-center gap-2'>
            <div className='w-7 h-7 bg-slate-100 rounded-full flex items-center
                            justify-center'>
              <span className='text-xs font-semibold text-slate-600'>
                {email.charAt(0).toUpperCase()}
              </span>
            </div>
            <span className='text-xs text-slate-500'>{email}</span>
          </div>
          <button onClick={onLogout}
            className='flex items-center gap-1.5 text-xs text-slate-400
                       hover:text-red-500 transition-colors px-2 py-1.5
                       rounded-lg hover:bg-red-50'>
            <LogOut size={13} /> Çıkış
          </button>
        </div>
      </div>
    </header>
  );
}